import React from 'react';

import { ErrorMessage } from '@eika/attention-message';
import { SmallButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { useDebitAccountsQuery } from '@/react-query/hooks/query/accounts/use-debit-accounts';
import { useMyDebitCards } from '@/react-query/hooks/query/use-debit-cards';

import { useSession } from '@components/app/Session';
import CardSkeleton from '@components/skeleton/CardSkeleton';
import useText from '@hooks/use-text';

import { DebitCardsContent } from './debit-card-content';

export const DebitCards = () => {
    const cardsQuery = useMyDebitCards();
    const debitAccountsQuery = useDebitAccountsQuery();
    const text = useText();
    const { debitProfile } = useSession();

    if (cardsQuery.isError || debitAccountsQuery.isError) {
        const refetch = () => {
            if (cardsQuery.isError) {
                cardsQuery.refetch();
            }
            if (debitAccountsQuery.isError) {
                debitAccountsQuery.refetch();
            }
        };
        return (
            <ErrorMessage
                text={text.messageFetchCardsForCardsOverviewError}
                icon={IconTypes.LUKK_24}
                clickableItem={<SmallButton onClick={refetch}>{text.genericTryAgain}</SmallButton>}
            />
        );
    }
    if ((debitProfile && cardsQuery.isPending) || debitAccountsQuery.isPending) {
        return <CardSkeleton />;
    }

    return <DebitCardsContent debitCards={cardsQuery.data ?? []} debitAccounts={debitAccountsQuery.data} />;
};
